import { render, staticRenderFns } from "./DescriptionComboboxSearch.vue?vue&type=template&id=4fd16332&scoped=true&"
import script from "./DescriptionComboboxSearch.vue?vue&type=script&lang=js&"
export * from "./DescriptionComboboxSearch.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionComboboxSearch.vue?vue&type=style&index=0&id=4fd16332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd16332",
  null
  
)

export default component.exports